'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'plane';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f072';
var svgPathData = ['M61 144l27 108.1 1 3.9-1 3.9-27 108.1 19.8 0 59.2-74 4.8-6 399.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-399.7 0-4.8-6-59.2-74-19.8 0zM198.7 32l53.3 160 144.1 0-146.7-160-50.8 0zm0 448l50.8 0 146.7-160-144.1 0-53.3 160z', 'M544.5 192c35.3 0 64 28.7 64 64s-28.7 64-64 64l-105 0-171.2 186.8-4.8 5.2-109.2 0 7-21.1 57-170.9-58.1 0-59.2 74-4.8 6-76.2 0 5-19.9 31-124.1-31-124.1-5-19.9 76.2 0 4.8 6 59.2 74 58.1 0-57-170.9-7-21.1 109.2 0 4.8 5.2 171.2 186.8 105 0zm32 64c0-17.7-14.3-32-32-32l-399.7 0-4.8-6-59.2-74-19.8 0 27 108.1 1 3.9-1 3.9-27 108.1 19.8 0 59.2-74 4.8-6 399.7 0c17.7 0 32-14.3 32-32zM396.1 320l-144.1 0-53.3 160 50.8 0 146.7-160zM249.5 32l-50.8 0 53.3 160 144.1 0-146.7-160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlane = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;